import React, {useEffect} from "react";
import {connect, useSelector} from "react-redux";


// components
import AybMenuList from "../../ayb/menu/_list";
import {showLoader} from "../../../components/loader/loader";


// actions
import {
    ADD_STATE,
    REMOVE_STATE,
    setUdn,
    setApp,
    setCategory, setUserIsAdmin
} from "../../../redux/actions/generics/IndexedActions";

// utils
import {getStateByPath} from "../../../redux/selectors";


import '../../../assets/css/DragAndDrop.css';



const AybMenu = (props) => {
    const path = '/hotel/rest';
    const componentState = useSelector(state => getStateByPath(state, path));
    const {loading} = componentState?.data || false;

    useEffect(() => {
        props.ADD_STATE(path);

        return () => {
            props.REMOVE_STATE(path);
        }
    }, []);

    useEffect(() => {
        props.setCategory('REST');

        const _udn = localStorage.getItem('selectedUdn') !== '' ? JSON.parse(localStorage.getItem('selectedUdn')) : null
        if (_udn !== null) {
            props.setUdn(path, _udn);
        }

        if (props.app !== null)
            props.setApp(path, props.app);

        if (props.categoryCode !== undefined && props.categoryCode !== null) {
            props.setCategory(path, props.categoryCode);
        }

        const userStorage = localStorage.getItem('userData')
        if (userStorage && userStorage !== 'undefined') {
            try {
                const user = JSON.parse(userStorage);
                if (user?.isAdmin)
                    props.setUserIsAdmin(path, true)
                else
                    props.setUserIsAdmin(path, false)

            } catch (e) {
                console.error(e);
            }
        }
    },[]);

    return <>
        { loading && showLoader() }
        { componentState && <AybMenuList path={path} /> }
    </>
}

const mapStateToProps = _ => ({
});

const mapActionsToProps = ({
    ADD_STATE,
    REMOVE_STATE,
    setApp,
    setUdn,
    setCategory,
    setUserIsAdmin
})

export default connect(mapStateToProps, mapActionsToProps)(AybMenu);